<script>
export default {
  name: 'VNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
  render(createElement) {
    return createElement(this.tag, [this.node]);
  },
};
</script>
